import { t } from 'i18next';
import * as yup from 'yup';

import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';

export const upsertElementTemplateSchema = () =>
  yup.object().shape({
    customIdentifier: yup
      .string()
      .label(t('headerIdentifier'))
      .nullable()
      .required(getEmptyErrorMessage(t('headerIdentifier'))),
    description: yup
      .string()
      .label(t('headerDescription'))
      .nullable()
      .required(getEmptyErrorMessage(t('headerDescription'))),
    id: numberSchemaWithTransform().nullable(),
  });
